






























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { BCol, BRow, BAlert } from 'bootstrap-vue';
import { ZenEllipsis } from 'zenComponents';
import LoadingState from '@/components/cards/loading_state/LoadingState.vue';
import { Alert } from '@/components/global_alerts/types';
import { ModalSize } from '@/components/zen_modal/types';

export default Vue.extend({
  name: 'RiskCalculationMethod',
  components: {
    BCol,
    BRow,
    BAlert,
    LoadingState,
    ZenEllipsis,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: <Boolean>true,
      factors: <Array<string>>[],
      vectors: <Array<string>>[],
      scores: <Array<string>>[],
      vectorCalculations: <Array<string>>[],
      scoreCalculations: <Array<string>>[],
      alerts: <Alert[]>[],
    };
  },
  async created() {
    this.changeModalSize(ModalSize.Medium);
    try {
      const resp = await this.request({ url: this.url });
      this.factors = resp['factors'];
      this.vectors = resp['vectors'];
      this.scores = resp['scores'];
      this.vectorCalculations = resp['vectorCalculations'];
      this.scoreCalculations = resp['scoreCalculations'];
    } catch (errors) {
      this.alerts = [errors.response.data];
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      request: 'request',
    }),
  },
});
